export function determineSectionId(sectionname: string) {
  return encodeURIComponent(sectionname.toLowerCase());
}
